import * as React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import { SmartToyOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const shimmer = keyframes`
    0%, 100% { opacity: 0.85; }
    50% { opacity: 1; }
`;

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.16)} 0%, ${alpha(theme.palette.primary.dark, 0.16)} 100%)`,
    color: theme.palette.primary.main,
    animation: `${shimmer} 2.8s ease-in-out infinite`,
    transition: 'transform 0.2s ease, background 0.2s ease',
    '&:hover': {
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.28)} 0%, ${alpha(theme.palette.primary.dark, 0.28)} 100%)`,
        transform: 'scale(1.08)',
    },
    ...theme.applyStyles('dark', {
        color: theme.palette.primary.light,
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.22)} 0%, ${alpha(theme.palette.primary.dark, 0.22)} 100%)`,
        '&:hover': {
            background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.34)} 0%, ${alpha(theme.palette.primary.dark, 0.34)} 100%)`,
        },
    }),
}));

interface AIChatTriggerButtonProps {
    onClick: () => void;
    open?: boolean;
    size?: 'small' | 'medium';
}

const AIChatTriggerButton: React.FC<AIChatTriggerButtonProps> = ({ onClick, open = false, size = 'medium' }) => {
    const { t } = useTranslation();

    if (open) return null;

    return (
        <Tooltip title={t('ai.chat.openTooltip')} arrow>
            <StyledIconButton
                onClick={onClick}
                aria-label={t('ai.chat.openTooltip') ?? ''}
                size={size}
            >
                <SmartToyOutlined fontSize={size} />
            </StyledIconButton>
        </Tooltip>
    );
};

export default AIChatTriggerButton;
